export enum StorageModuleType {
  C_0PT1 = 'C_0PT1',
  C_0PT2 = 'C_0PT2',
  C_0PT5 = 'C_0PT5',
  C_1 = 'C_1',
  C_2 = 'C_2',
  C_5 = 'C_5',
}
export const storageModuleTypeToLabel = {
  [StorageModuleType.C_0PT1]: '0.1C',
  [StorageModuleType.C_0PT2]: '0.2C',
  [StorageModuleType.C_0PT5]: '0.5C',
  [StorageModuleType.C_1]: '1C',
  [StorageModuleType.C_2]: '2C',
  [StorageModuleType.C_5]: '5C',
};
